var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"to":{ name: 'settings' },"link-classes":"btn-navbar"}},[_c('i',{staticClass:"nav-link__icon fas fa-cogs mr-0"}),(_vm.showLabel)?_c('span',{staticClass:"nav-link__text"},[_vm._v(_vm._s(_vm.$t('message.navMain.settings')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }